import type { FilterOperator } from '@/lib/types/filter'

export const OPERATOR_LABELS: Record<FilterOperator, string> = {
  includes: 'is',
  excludes: 'is not',
  at_least: '≥',
  equals: 'equals',
  not_equal: 'not equal',
  contains: 'contains',
  does_not_contain: 'does not contain',
  greater_than: 'greater than',
  less_than: 'less than',
  before: 'before',
  after: 'after',
  on: 'on',
}

/** Longer labels for the operator menu, where a bare symbol needs a gloss. */
export const OPERATOR_MENU_LABELS: Partial<Record<FilterOperator, string>> = {
  at_least: '≥ at least',
}
